import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/ModalBox/modal-box';
export var ModalBoxDescription = function ModalBoxDescription(_a) {
  var _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$id = _a.id,
      id = _a$id === void 0 ? '' : _a$id,
      props = __rest(_a, ["children", "className", "id"]);

  return React.createElement("div", Object.assign({}, props, {
    id: id,
    className: css(styles.modalBoxDescription, className)
  }), children);
};